import React from 'react'
import { connect } from 'react-redux'
import { Page } from '../../../components/page/Page'
import { DefaultFormToolBar } from '../../../components/toolbar/DefaultFormToolBar'
import { routes } from '../../../constants'
import { actions } from '../webhookPixPagamento.actions'
import { WebhookPixPagamentoForm } from './WebhookPixPagamentoForm'
import utils from '../../../utils'
import storage from '../../../services/stoage.service'
import _ from 'lodash'
import { logarAcesso } from '../../../services/api-log-acesso'

const mapStateToProps = (state) => {
  let unidades = utils.getListIdValuesUnidadeFromEmpresa(storage.getCompany())

  return {
    record: state.crudWebhookPixPagamentoState.currentRecord,
    messages: state.crudWebhookPixPagamentoState.messages,
    unidades,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setField: (field, value) => dispatch(actions.setField(field, value)),
    saveHandler: (event) => {
      dispatch(actions.save())
    },
    removeHandler: (event) => {
      dispatch(actions.remove())
    },
    newHandler: (event) => {
      dispatch(actions.makeNew())
    },
    loadById: (oid) => dispatch(actions.loadById(oid)),
  }
}

class WebhookPixPagamentoFormPageContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showDialogRemove: false,
      descricaoChanged: false,
    }

    actions.afterSave = ({ oid }) => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_PIX_PAGAMENTO}/${oid}`)
    }
    actions.afterNew = () => {
      this.props.history.push(`${routes.PATH_WEBHOOK_PIX_PAGAMENTO}/novo`)
    }
    actions.afterRemove = () => {
      this.props.history.replace(`${routes.PATH_WEBHOOK_PIX_PAGAMENTO}`)
    }

    actions.beforeFetchRecordSuccess = (data) => {
      return data
    }
  }

  componentDidMount() {
    const oidEntity = _.get(this, 'props.match.params.id', null)
    logarAcesso(oidEntity).then()
    if (oidEntity && parseInt(oidEntity)) {
      this.props.loadById(oidEntity)
      this.setState({ descricaoChanged: true })
    } else {
      this.props.newHandler()
    }
  }

  searchHandler = () => {
    this.props.history.push(`${routes.PATH_WEBHOOK_PIX_PAGAMENTO}`)
  }

  hideDialog = () => {
    this.setState({ showDialogRemove: false })
  }

  onChangeDescricao = (e) => {
    this.props.setField('descricao', e)
    this.setState({ descricaoChanged: true })
  }

  onChangeField = (fieldName, e) => {
    const field = _.get(e, 'target.name', null)
    if (field === 'ativo') {
      this.props.setField(field, _.get(e, 'target.checked', null))
      return
    }
    this.props.setField(fieldName, e)
  }

  buildHeader = () => {
    return <DefaultFormToolBar formPageContainer={this} />
  }

  render() {
    const content = (
      <WebhookPixPagamentoForm
        record={this.props.record}
        messages={this.props.messages}
        onChangeDescricao={this.onChangeDescricao}
        onChangeField={this.onChangeField}
      />
    )

    return <Page header={this.buildHeader()} content={content} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(WebhookPixPagamentoFormPageContainer)
